import { createContext, useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import { apiBaseURL } from "../config";
import { useToast } from "@chakra-ui/react";

export const GlobalContext = createContext();

console.log("version 1.8.2")

const tokenPromise = fetch(`${apiBaseURL}/auth/register/guest`, {
  method: "POST",
})
  .then((resp) => resp.json())
  .catch((err) => console.log(err));

export const GlobalProvider = ({ children }) => {
  const toast = useToast();
  const userData = Cookies.get("userInfo");
  const [userInfo, setUserInfo] = useState(
    userData ? JSON.parse(userData) : userData
  );
  const [loggedIn, setLoggedIn] = useState(
    userInfo ? userInfo.email !== undefined : false
  );
  const [settings, setSettings] = useState({
    theme: {
      skin: "clear",
      view: "box",
      topbar: "light",
      layout: "boxed",
      degraded: "degraded",
      workspace: "workspace-color2",
      mainColor: "main-color1",
      secondColor: "secondary-color1",
    },
    modals: {
      show: false,
      title: "NOTIFICATIONS",
      icon: "icon-notification",
      id: "modal-notifications",
    },
    message: {
      show: false,
      status: "ok",
      data: "OK",
      fn: () => { },
    },
    console: {
      show: false,
    },
  });

  const [showLogin, setShowLogin] = useState(false);

  const [organizations, setOrganizations] = useState([]);

  const [loading, setLoading] = useState(false);
  const fqlToken = useRef(undefined);
  const groupName = useRef(undefined);
  const groupOwnerEmail = useRef(undefined);
  const forms = useRef();

  const [sessionEnd, setSessionEnd] = useState(false);
  const sessionTimeOut = useRef();
  clearTimeout(sessionTimeOut.current);
  sessionTimeOut.current = setTimeout(() => setSessionEnd(true), 3600000);

  const runCode = async ({ code, token, FQLToken = fqlToken.current }) => {
    return fetch(`${apiBaseURL}/run_code`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify({
        code,
        token,
        fql_token: FQLToken,
        group_name: groupName.current,
        group_owner_email: groupOwnerEmail.current,
      }),
    })
      .then(async (res) => {
        // if (!res.ok) {
        //   const status = res.status;
        //   const statusText = res.statusText;
        //   const body = await res.json();
        //   throw new APIError({ body, status, statusText });
        // }
        return res.json();
      })
      .then((data) => {
        if (data.fql_token) fqlToken.current = data.fql_token;
        if (data.group_name) groupName.current = data.group_name;
        if (data.group_owner_email)
          groupOwnerEmail.current = data.group_owner_email;
        clearTimeout(sessionTimeOut.current);
        sessionTimeOut.current = setTimeout(() => {
          setSessionEnd(true);
        }, 3600000);
        return data;
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  };

  const runCommands = async ({ commands, token = userInfo.token }) => {
    return fetch(`${apiBaseURL}/run_commands`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify({
        commands: commands,
        token,
        fql_token: fqlToken.current,
      }),
    })
      .then((resp) => resp.json())
      .catch((err) => {
        console.error(err);
        // throw err;
      });
  };

  const createSession = async () => {
    return fetch(`${apiBaseURL}/session`, {
      method: 'POST',
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${userInfo.token}` },
      body: JSON.stringify({ token: userInfo.token })
    }).then((res) => res.json());
  };

  const getToken = async () => {
    await tokenPromise
      .then((data) => {
        if (userData) {
          const user = JSON.parse(userData);
          setUserInfo(user);
          if (user.token) {
            getOrganizations(user.token);
          }
        } else {
          setUserInfo({ token: data.token });
        }
      })
      .catch((err) => console.log(err));
  };

  const getOrganizations = (token = null) => {
    runCode({ code: "show organizations", token: token })
      .then((data) => {
        if (!data.error) {
          setOrganizations(data.output);
        } else {
          toast({
            title: "Error",
            description: data.msg,
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "bottom-right",
          });
        }
      })
      .catch((err) => {
        toast({
          title: "Error",
          description: err.toString(),
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "bottom-right",
        });
      });
  };

  const doLogout = async () => {
    await tokenPromise
      .then((data) => {
        setUserInfo({ token: data.token });
        setLoggedIn(false);
        Cookies.remove("userInfo");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getToken();
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        userInfo,
        setUserInfo,
        settings,
        setSettings,
        loggedIn,
        setLoggedIn,
        runCode,
        runCommands,
        createSession,
        organizations,
        setOrganizations,
        fqlToken,
        groupName,
        groupOwnerEmail,
        forms,
        loading,
        setLoading,
        doLogout,
        sessionEnd,
        setSessionEnd,
        showLogin,
        setShowLogin,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
